import { student_commitment, user } from '@prisma/client';

export enum NotesType {
  MOTIVATION = 'Motivation / Why',
  LIMITLESS = 'Limitless Meeting',
  OTHER_MEETING = 'Other Meeting',
  PROGRESS = 'Progress Note',
  MESSAGE = 'Student Message',
  GOAL = 'Student Goal',
  OTHER = 'Other Note',
  AI = 'Ai Feedback',
  WEEKLY_TRACKER = 'Weekly Tracker Note'
}

export enum NotesCategory {
  POINTS = 'Points',
  ROCKETSHIP = 'Rocketship',
  PRAISE = 'Praise',
  CLUBS = 'Clubs',
  OTHER = 'Other'
}

export interface PNote {
  id?: number;
  user_id: number;
  date: string;
  type: NotesType;
  note: string;
  category?: string;
}

export interface PReward {
  id?: number;
  user_id: number;
  date: string;
  value: string;
  description: string;
}

// User with guide relation included
export interface UserWithGuide extends user {
  guide?: user | null;
}

export interface Note {
  id: number;
  date: string;
  type: NotesType;
  note: string;
  category?: string;
  user_id: number;
  admin_id: number;
  created_at: string;
  updated_at: string;
  admin: user;
  user: UserWithGuide;
}

export interface Reward {
  id: number;
  date: string;
  value: string;
  description: string;
  user_id: number;
  admin_id: number;
  created_at: string;
  updated_at: string;
  admin: user;
  user: user;
}

export interface StudentCommitment extends student_commitment {
  user: user;
  admin: user;
}
